// src/pages/Checkout.js
import React, { useEffect } from "react";
import Cart from "../Components/Cart";

const Checkout = () => {
  useEffect(() => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.expand();
      window.Telegram.WebApp.setBackgroundColor("#EBF0F3");
    }
  }, []);

  return (
    <div className="bg-[#EBF0F3] min-h-screen p-4">
      <header className="mb-4">
        <h1 className="text-2xl font-bold">Checkout</h1>
      </header>
      <Cart /> {/* Cart component should display prices in € */}
    </div>
  );
};

export default Checkout;
